module.exports = __webpack_public_path__ + "img/cash.51afb00e.svg";